import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon from 'tbk-components/src/components/Icon';

export interface ILocationNavPageProps extends IBaseElementProps {
	children?: any;
}

const LocationNavPage: React.FC<ILocationNavPageProps> = ({
	children,
	className,
	classNames = [],
}) => (
	<div className={className || cn('location-nav-page', ...classNames)}>
		<button
			type="button"
			className="btn-close-main-offcanvas"
			aria-label="Close Menu"
			onClick={() => {
				const btnClose = document.querySelector(
					'.main-nav__content .btn-close',
				);
				btnClose && (btnClose as HTMLButtonElement).click();
			}}
		>
			<i className="icon icon-close"></i>
		</button>
		<div className="location-nav-page__content">{children}</div>
	</div>
);

export default LocationNavPage;
